import { useRef, useEffect, useCallback, useContext } from 'react'
import classNames from 'classnames'
import { createUseStyles } from 'react-jss'
import { useSelector, shallowEqual } from 'react-redux'
import gsap from 'gsap'
import useMouse from '@/hooks/useMouse'
import { Context as LoadingContext } from '@/context/loading'
import { useResize } from '@/components/Handlers'
import style from './style'

const useStyles = createUseStyles(style)

const MagneticWrapper = ({
  className,
  children,
  aboveTheFold,
  onMouseEnter,
  onMouseLeave,
}) => {
  const classes = useStyles(style)
  const { ready } = useContext(LoadingContext)
  const $root = useRef()
  const $item = useRef()
  const boundingRef = useRef()
  const mouse = useRef({ x: 0, y: 0 })
  const { mediaQueryKey } = useSelector((state) => ({
    mediaQueryKey: state.mediaQuery.key,
  }), shallowEqual)

  /*------------------------------
  Calculate Bounds
  ------------------------------*/
  const calculateBound = () => {
    boundingRef.current = $root.current.getBoundingClientRect()
  }

  /*------------------------------
  Resize
  ------------------------------*/
  useResize(() => {
    calculateBound()
  })

  /*------------------------------
  Ready
  ------------------------------*/
  useEffect(() => {
    if (ready && aboveTheFold) {
      setTimeout(() => {
        calculateBound()
      }, 2000)
    }
  }, [ready])

  /*------------------------------
  Use Mouse
  ------------------------------*/
  useMouse(({ x, y }) => {
    if ($root.current && mediaQueryKey > 1) {
      mouse.current.x = x
      mouse.current.y = y
    }
  })

  /*------------------------------
  HandleMouseEnter
  ------------------------------*/
  const handleMouseEnter = useCallback(() => {
    onMouseEnter()
    const bounds = $root.current.getBoundingClientRect()
    const centerX = bounds.left + bounds.width / 2
    const centerY = bounds.top + bounds.height / 2

    const distanceX = Math.min(bounds.width / 2, mouse.current.x - centerX) * 0.05
    const distanceY = Math.min(bounds.height, mouse.current.y - centerY) * 0.05
    // const rotation = Math.atan(distanceX, distanceY)

    gsap.to($item.current, {
      duration: 0.6,
      // rotationX: `${distanceY}px`,
      // rotationY: `${distanceX}deg`,
      // rotationZ: `${rotation}deg`,
      x: distanceX * 2,
      y: distanceY * 2,
      ease: 'power4.out',
    })
  }, [mouse])

  /*------------------------------
  HandleMouseEnter
  ------------------------------*/
  const handleMouseLeave = () => {
    onMouseLeave()
    gsap.to($item.current, {
      duration: 0.7,
      // rotationX: '0deg',
      // rotationY: '0deg',
      // rotationZ: '0deg',
      x: 0,
      y: 0,
      ease: 'power4.out',
    })
  }

  /*------------------------------
  Render
  ------------------------------*/
  return (
    <div
      onMouseMove={handleMouseEnter}
      onMouseLeave={handleMouseLeave}
      ref={$root}
      className={classNames({
        [classes.root]: true,
        magneticWrapper: true,
        [className]: className,
      })}
    >
      <div ref={$item} className={classes.item}>
        {children}
      </div>
    </div>
  )
}

MagneticWrapper.defaultProps = {
  inview: true,
  enterImg: false,
  fadeIn: false,
  aboveTheFold: false,
}

export default MagneticWrapper
